import { SwitchProps } from '@mui/material';

import { camelCaseToUserText } from '@dw/utils';

import { SwitchInput } from '../SwitchInput';
import { useFormContext } from './Form.Context';

interface IFormSwitchInputProps<T> extends Omit<SwitchProps, 'name' | 'disabled' | 'checked' | 'onChange'> {
    label?: string;
    name: keyof T;
    disabled?: boolean;
}

/** A form field's switch. The switch itself is `SwitchInput`, which non-form state uses directly. */
export function FormSwitchInput<T>(props: IFormSwitchInputProps<T>) {
    const {
        label,
        name,
        disabled,
        ...baseInputProps
    } = props;

    const {
        formData,
        handleFormChange,
        disabled: formDisabled,
        formErrors,
        submitAttempted,
        customFormErrors
    } = useFormContext<T>();

    return (
      <SwitchInput
        {...baseInputProps}
        label={label ?? camelCaseToUserText(String(name))}
        name={String(name)}
        checked={(formData[name] as boolean) ?? false}
        onChange={(checked) => handleFormChange(name, checked)}
        disabled={disabled || formDisabled}
        error={submitAttempted && !!formErrors[name] && !!customFormErrors[name]}
      />
    )
};
